import s from './index.module.sass'

export default function Radio({checked = false}) {
  return (
    <label className={s.container}>
      <input type="checkbox" disabled checked={checked} />
      <span className={s.checkmark}></span>
    </label>
  )
}